import { Component } from 'react';
import IconX from './IconX.js';
import IconCheck from './IconCheck.js';
import IconInfo from './IconInfo.js';
import IconPadlock from './IconPadlock.js';

class Check extends Component {
	constructor(props) {
		super(props);
		this.state = {
			checked: null,
			marked: false,
			value: null,
			comment: '',
			optimalMin: null,
			optimalMax: null,
		}
		this.handleShowProblemClick = this.handleShowProblemClick.bind(this);
		this.handleClearMarks = this.handleClearMarks.bind(this);
	}

	componentDidMount() {
		if (this.props.reportCallback && !this.props.excludeFromScore) {
			this.props.reportCallback(this.props.id, 'mount')
		}
	}

	componentWillUnmount() {
		window.removeEventListener('clearMarks', this.handleClearMarks);
	}

	handleClearMarks() {
		this.setState({
			marked: false
		})
	}

	runTest() {
		let content = this.props.postData;
		const settings = this.props.appSettings;
		let result = this.props.test(content, settings);
		let checked = typeof result.status !== 'undefined' ? result.status : null;

		this.setState({
			checked: checked,
			comment: result.comment || '',
			value: (result.value || result.value === 0) ? result.value : '',
			optimalMin: typeof result.optimalMin !== 'undefined' ? result.optimalMin : null,
			optimalMax: typeof result.optimalMax !== 'undefined' ? result.optimalMax : null
		});

		if (this.props.selected) {
			this.props.showProblem(settings, content.content);
		}
	}

	scrollToProblem() {
		const mark = document.querySelector('.tiptap mark, .tiptap .mark');
		if (mark) {
			mark.scrollIntoView();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.test) {
			if (prevProps !== this.props) {
				this.runTest();
			}

			if (this.props.reportCallback && prevState.checked !== this.state.checked) {
				this.props.reportCallback(this.props.id, this.state.checked ? 'pass' : 'fail');
			}
		}
	}

	handleShowProblemClick() {
		let {content} = this.props.postData;
		let updatedContent = '';
		if (this.props.selected) {
			updatedContent = content.replaceAll('<mark>', '').replaceAll('</mark>', '');
		} else {
			updatedContent = this.props.showProblem(this.props.appSettings, content);
		}

		this.props.contentCallback(updatedContent);

		if (this.props.selected) {
			this.props.selectCheckCallback('');
		} else {
			this.props.selectCheckCallback(this.props.id);
		}
		setTimeout(this.scrollToProblem, 0);
	}

	render () {
		let checkedClass = '';
		let icon = '';
		switch (this.state.checked) {
			case 'info':
				checkedClass = 'info';
				icon = this.props.noIcon ? '' : <IconInfo />;
				break;
			case true:
				checkedClass = 'ok';
				icon = <IconCheck />;
				break;
			case false:
				checkedClass = 'nok';
				icon = <IconX />;
				break;
			default:
				checkedClass = '';
		}
		let classes = [
			'check-list-item check',
			this.props.id,
			this.props.selected && !this.state.checked ? 'marked' : '',
			this.state.checked !== null && !this.props.inPro ? checkedClass : '',
			this.props.noIcon ? 'no-icon' : '',
		];
		let checkLabel = this.props.label;
		const settings = this.props?.appSettings;
		for (let option in settings) {
			let optionTag = `[${option}]`;
			checkLabel = checkLabel.replace(optionTag, settings[option]);
		}
		if (this.props.inPro) {
			return (
				<p className={classes.join(' ')}><span className="masked">{checkLabel}</span> <b><a href="https://diagnoseo.com/pricing/" target="_blank" rel="noreferrer noopener" className="unlock"><IconPadlock />{window?.t?.UNLOCK}</a></b></p>
			);
		}
		const value = this.state.value !== '' ? <b>{this.state.value}</b> : '';
		const showProblemLink = !this.state.checked && this.props.showProblem ? (<button onClick={this.handleShowProblemClick} className="show-problem" title={window?.t?.SHOW_PROBLEM}></button>) : '';
		let optimalText = '';
		let optimalMin = typeof this.state.optimalMin !== 'undefined' ? this.state.optimalMin : null;
		let optimalMax = typeof this.state.optimalMax !== 'undefined' ? this.state.optimalMax : null;

		if (optimalMin !== null && optimalMax !== null) {
			optimalText = ` (${optimalMin} - ${optimalMax})`;
		} else if (optimalMin !== null && optimalMax === null) {
			optimalText = ` (${window?.t?.UP_TO} ${optimalMin})`;
		} else if (optimalMin === null && optimalMax !== null) {
			optimalText = ` (${window?.t?.AT_LEAST} ${optimalMax})`;
		}
		checkLabel += optimalText;
		const comment = (<span className="hint">{this.state.comment}</span>) || '';

		let labelLink = this.props.needsSeoData && optimalMin === null && optimalMax === null ? (<a href="#keyword-loader">{window?.t?.GET_DATA}</a>) : '';

		return this.props.valueFirst
		? (
			<p className={classes.join(' ')}>{icon}{value} {checkLabel} {labelLink} {comment} {showProblemLink}</p>
		)
		: (
			<p className={classes.join(' ')}>{icon}{checkLabel} {labelLink} {value} {comment} {showProblemLink}</p>
		);
	}

}

export default Check;